import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn:'root'
})
export class UploadService {
    constructor() { }
    sendData = new Subject<any>();
    output(operation: string, data: any) {
        this.sendData.next({ operation, data });
    }

}